import React from 'react'
import PropTypes from 'prop-types'
import HeadingBeta from '../headings/heading-beta'
import ModalWrapper from '../modal/modal-wrapper'
import Subtitle from '../texts/subtitle'
import ConfirmationMsg from '../messages/confirmation-msg'
import Icon from '../icons/icon'
import FlatButton from '../buttons/flat-button'
import CtaButton from '../buttons/cta-button'
import MsgIntro from '../messages/msg-intro'
import { t } from '../../core/i18n'

const AlertFinishedWin = props => (
  <ModalWrapper onClose={props.onClose}>
    <ConfirmationMsg className='no-top-space'>
      <div className='center'>
        <MsgIntro>
          <HeadingBeta center>Congratulations {props.userName}!</HeadingBeta>
          <Icon name='congrats' />
        </MsgIntro>
        <Subtitle>
          <strong>{props.auctionTitle}</strong> has finished!
        </Subtitle>
        <Subtitle>
          <span>
            You are the winner of&nbsp;
            <strong>
              {t('common:itemWithCount', { count: props.wonItemCount })}
            </strong>
            .
          </span>
          {props.lostItemCount > 0 && (
            <span>
              <br />
              You were outbid for&nbsp;
              <strong>
                {t('common:itemWithCount', { count: props.lostItemCount })}
              </strong>
              .
            </span>
          )}
        </Subtitle>
      </div>
      {props.checkoutId && (
        <div className='full-width bottom-space'>
          <CtaButton
            text='Fill in details to pick up my products'
            onClick={props.onGoToCheckout}
          />
        </div>
      )}
      <div className='full-width'>
        <FlatButton text='I will do it later ...' onClick={props.onClose} />
      </div>
    </ConfirmationMsg>
  </ModalWrapper>
)

AlertFinishedWin.propTypes = {
  onClose: PropTypes.func,
  onGoToCheckout: PropTypes.func,
  userName: PropTypes.string,
  auctionTitle: PropTypes.string,
  checkoutId: PropTypes.string,
  wonItemCount: PropTypes.number,
  lostItemCount: PropTypes.number,
  wonItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      item: PropTypes.string
    })
  )
}

export default AlertFinishedWin



// WEBPACK FOOTER //
// ./src/ui/alerts/alert-finished-win.js